import app from '@/main'

import _clone from 'lodash.clonedeep'

import {
  VUEX_GRID_ROWS_ADD,
  VUEX_GRID_ROWS_REMOVE,

  VUEX_GRID_REQUEST_SNAPSHOT,

  VUEX_GRID_IMPORT_SPREADSHEET_CLOSE,

  VUEX_GRID_LIST_SET_FILTER
} from '@/store/constants/ui/grid'

const state = {
  // currently used in the list of Key Initiatives, but could be extended
  // it's for when you click the back button it remembers your last filter
  lookupFilterSavedState: ''
}

const getters = {}

const actions = {
  [VUEX_GRID_LIST_SET_FILTER]: ({ commit }, payload) => {
    commit(VUEX_GRID_LIST_SET_FILTER, payload)
  },

  [VUEX_GRID_ROWS_ADD]: ({ commit, dispatch }, payload) => {
    if (payload.length === 0) return

    let data = _clone(payload).map(item => {
      const lineStatus = (item.locations && item.locations.lineStatus) ? item.locations.lineStatus : null
      item['previousStatus'] = lineStatus
      return item
    })

    app.config.globalProperties.emitter.emit('aggrid-event', {
      type: 'rowsAdd',
      payload: data
    })
  },

  [VUEX_GRID_ROWS_REMOVE]: ({ commit, dispatch }, payload) => {
    if (payload.length === 0) return

    app.config.globalProperties.emitter.emit('aggrid-event', {
      type: 'rowsDelete',
      payload: payload
    })
  },

  [VUEX_GRID_REQUEST_SNAPSHOT]: ({ commit }) => {
    app.config.globalProperties.emitter.emit('aggrid-event', {
      type: 'snapshot'
    })
  },

  [VUEX_GRID_IMPORT_SPREADSHEET_CLOSE]: ({ commit }) => {
    app.config.globalProperties.emitter.emit('aggrid-event', {
      type: 'excelImporterClose'
    })
  }

}

const mutations = {
  [VUEX_GRID_LIST_SET_FILTER]: (state, payload) => {
    state.lookupFilterSavedState = payload.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
